import { IReduxAction, actionGenerator } from '../../utils/actions';
import { IElementsVisibilityState } from '../../types/reducers/elementsVisibility';

export const SET_ELEMENTS_VISIBILITY_PRESET = 'ELEMENTS_VISIBILITY :: SET_PRESET';

export type TSetElementsVisibilityPresetAction = IReduxAction<
  typeof SET_ELEMENTS_VISIBILITY_PRESET,
  IElementsVisibilityState
>;

export const setElementsVisibilityPreset = actionGenerator<
  typeof SET_ELEMENTS_VISIBILITY_PRESET,
  IElementsVisibilityState
>(SET_ELEMENTS_VISIBILITY_PRESET);
